// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1nLjX","calendarButtons":"ClockData_calendarButtons__shs7N"};